import { Component, Injector, LOCALE_ID, OnInit } from '@angular/core';
import * as moment from 'moment';
import { AuthService } from '@services/auth.service';
import { environment } from '../environments/environment'; // used in template
import { EnvironmentType } from '@models/environment.model';
import { Title } from '@angular/platform-browser';
import { MsalService } from '@azure/msal-angular';
import { NotificationService } from '@services/notification.service';
import { ServerNotificationService } from '@services/server-notification.service';
import { ActivatedRouteSnapshot, NavigationEnd, Router } from '@angular/router';
import { ApplicationInsightsService } from '@services/application-insights.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  navColor = 'bg-primary';

  constructor(
    private authService: AuthService,
    private injector: Injector,
    private msalService: MsalService,
    private notificationService: NotificationService,
    private serverNotificationService: ServerNotificationService,
    private titleService: Title
  ) {
    const locale = this.injector.get(LOCALE_ID);
    moment.locale(locale);
  }

  ngOnInit(): void {
    this.setNavColor();
    this.setTitle();

    this.msalService.initialize().subscribe(() => {
      this.authService.initialize();
      this.notificationService.init();
      this.serverNotificationService.init();
    });
  }

  setTitle() {
    if (environment.environmentType === EnvironmentType.Production) {
      this.titleService.setTitle('TRIP');
    } else {
      this.titleService.setTitle(`TRIP ${environment.environmentType}`);
    }
  }

  setNavColor() {
    let link = document.querySelector("link[rel~='icon']") as HTMLLinkElement;
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      link.type = 'image/svg+xml';
      document.head.appendChild(link);
    }

    switch (environment.environmentType) {
      case EnvironmentType.LocalST:
      case EnvironmentType.LocalFT:
      case EnvironmentType.LocalLocal:
        this.navColor = 'bg-local';
        link.href = 'assets/favicons/triplocal.svg';
        break;
      case EnvironmentType.FT:
        link.href = 'assets/favicons/tripft.svg';
        this.navColor = 'bg-ft';
        break;
      case EnvironmentType.AT:
        link.href = 'assets/favicons/tripat.svg';
        this.navColor = 'bg-at';
        break;
      case EnvironmentType.ST:
        link.href = 'assets/favicons/tripst.svg';
        this.navColor = 'bg-st';
        break;
      case EnvironmentType.Production:
        link.href = 'assets/favicons/tripprod.svg';
        this.navColor = 'bg-primary';
        break;
      default:
        link.href = 'assets/favicons/tripprod.svg';
        this.navColor = 'bg-primary';
        break;
    }
  }
}
